import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { unitStructureQuery } from 'api/queries';
import { SectionTitleButtons } from 'library/components/controls/layout/SectionTitleButtons';
import { ServiceAreaTabs } from 'library/components/controls/layout/tabs/ServiceAreaTabs';
import { PageContentTab } from 'library/components/controls/pageTemplates/PageContent';
import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import { reactPlugin } from 'main/azureInsights/config';
import { ErrorComponentFallback } from 'main/errors/ErrorComponentFallback';
import { UnitOVerview_Services_ServiceContracts } from 'main/routes/urls/RouteUrls';
import { MaintenancePlannerButton } from 'modules/Shared/Components/Buttons/MaintenancePlannerButton';
import { useResolvedUnitIds } from 'modules/Shared/Components/Hooks/useNumberParam';
import { isUnitMarine } from 'modules/Shared/State/unit';
import { servicesAreaTabsConfiguration } from 'modules/UnitOverview/servicesAreaTabsConfiguration';

const ServiceAreaPage = (): React.JSX.Element => {
	const { trackApplicationInteraction } = useAdobeTracking();
	const unitIds = useResolvedUnitIds();
	const { data: unit } = useSuspenseQuery(unitStructureQuery(unitIds.id));

	const tabs = useMemo(
		() =>
			isUnitMarine(unit?.mainSegment)
				? servicesAreaTabsConfiguration.filter(
						({ path }) =>
							path !== UnitOVerview_Services_ServiceContracts
					)
				: servicesAreaTabsConfiguration,
		[unit?.mainSegment]
	);

	return (
		<>
			<SectionTitleButtons>
				<MaintenancePlannerButton source="UnitOverview" />
			</SectionTitleButtons>
			<ServiceAreaTabs
				tabs={tabs}
				onTabClick={(tabPath) =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'UNITOVERVIEW Service Area Tab Navigation',
						selectedOptions: [{ attribute: 'tab', value: tabPath }],
					})
				}
			/>
			<PageContentTab ErrorFallbackComponent={ErrorComponentFallback} />
		</>
	);
};

export default withAITracking(
	reactPlugin,
	ServiceAreaPage,
	'UnitOverviewServiceAreaPage',
	'application-insight-container'
);
